<template>
  <div>
    <van-button type="default" @click="submit">提交</van-button>
    <!-- 弹窗 -->
    <AccountInfoPopup ref="aip" @success="accountInfoOk"></AccountInfoPopup>
    <AuthInfo ref="aui" @ok="authInfoOk" @cancel="authCancel" />
  </div>
</template>

<script>
import { Toast, Dialog, Notify } from 'vant';
import AccountInfoPopup from "./AccountInfoPopup";
import AuthInfo from "./AuthInfoPopup"
export default {
  components: { AccountInfoPopup, AuthInfo },
  data() {
    return {

    }
  },
  mounted() {
    document.getElementsByClassName('.van-dialog__confirm').getElementsByClassName('.van-button__text').innerHTML='去认证'
  },
  methods: {
    submit() {
      Dialog.confirm({
        message: '请认证',
        confirmButtonText: '去认证',
      }).then(() => {
        // on close
        this.$refs['aip'].show()
      });
    },
    accountInfoOk(data) {
      this.$refs["aip"].close();
      this.$refs["aui"].setForm(data);
      this.$refs["aui"].show();
    },
    authInfoOk(data) {
      this.$refs["aui"].close();
      Toast.success('实名认证成功')
    },
    authCancel() {
      this.$refs["aui"].close();
      this.$refs["aip"].show();
    },
  }
}
</script>

<style scoped lang="less">
</style>

bbb663c572b40396